import OktaAuth from '@okta/okta-auth-js';

import { expiredTokenHandler } from 'helpers/expired-token-handler';

import config from 'utils/okta/okta.config';

const oktaAuth = new OktaAuth(config);

export default oktaAuth;

export const useOkta = (): OktaAuth => oktaAuth;

oktaAuth.tokenManager.on('error', (error: unknown) => {
  const description =
    typeof error === 'object' &&
    error !== null &&
    'error_description' in error &&
    typeof (error as { error_description?: unknown }).error_description ===
      'string'
      ? (error as { error_description: string }).error_description
      : '';

  if (description.includes('The refresh token is invalid or expired')) {
    sessionStorage.setItem('expiredRefreshToken', 'true');
    expiredTokenHandler(oktaAuth);
  }
});
